/* eslint-disable max-len */

// ERROR MESSAGES
export const NOT_AVAILABLE_FOR_SELECTED_DATE = 'There are no reservations available. Please choose a different date.';
export const NOT_AVAILABLE_FOR_SELECTED_PERIOD = 'We couldn\'t find any locations with availability for your rental criteria. Please adjust your reservation period.';
export const NOT_AVAILABLE_FOR_SELECTED_DATE_AT_STORE = 'We’re sorry. There isn’t availability at this location for the day and time you chose.';
export const NOT_RESERVABLE_PRODUCT = 'This item is only available for rent in-store. Please visit a Home Depot store to rent.';
export const NOT_RESERVABLE_VEHICLE = 'This vehicle is only available for rent in-store. Please visit a Home Depot store to rent.';
export const CANCEL_CALL_FAILED = 'We\'re sorry, there was a problem processing your request. \nPlease try again later or contact your Rental Center to cancel this reservation.';
export const UNABLE_TO_VALIDATE_CANCEL_CALL = 'Unfortunately, we are unable to validate this reservation. \nPlease contact your Rental Center to cancel this reservation.';
export const NOT_ABLE_TO_CANCEL = {
  expired: 'has already expired',
  cancel: 'has already been canceled',
  release: 'has already been fulfilled'
};
export const TERMS_ERROR = 'Please accept the Terms and Conditions to complete your reservation';
export const STATEMENTS_ERROR = 'Please accept the Statements of Understanding to complete your reservation';

// AVAILABILITY MESSAGES
export const NO_AVAILABILITY = 'We couldn\'t find any locations with availability for your rental criteria. Please adjust your reservation period.';
export const CLOSEST_AVAILABILITY = 'Showing locations with availability similar to the date and times you chose.';
export const EXACT_AVAILABILITY = 'Here are the options for the dates and times you chose or similar availability.';

// LABELS
export const EXACT_MATCH_LABEL = 'Exact Match';
export const CLOSEST_MATCH_LABEL = 'Close Match';
export const UNAVAILABLE_MATCH_LABEL = 'Unavailable';

// FORM MESSAGES
export const FORM_FIELD_MESSAGE = {
  pickupDate: 'Please select a pickup date',
  pickupTime: 'Please select a pickup time',
  dropoffDate: 'Please select a dropoff date',
  dropoffTime: 'Please select a dropoff time',
  deliveryDate: 'Please select a delivery date',
  deliveryTime: 'Please select a delivery time',
};
